/* @flow */
import type { SearchField } from './SearchField';
import type { SearchFilter } from './SearchFilter';

export type SearchParams = {
  text: string,
  flags?: {
    [SearchField]: boolean,
  },
  filters?: {
    [SearchFilter]: string[],
  },
};

export const searchParamsProps = ['text', 'flags', 'filters'];
